module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_pp3_3.81b536aa.png";